import React from 'react'
import { useTranslation } from '../../utils/convergence'
import { Head, PaymentTypes } from '../../../src/component'
import { TrackOnMount } from '../../../src/integrations/monitoring'
import { CheckoutPage } from '../../../src/model'
import { TrackingEvent } from '../../../src/model/monitoring'
import { useOfferDetailPCL, usePBIRejected, usePreselectedPaymentType } from '../../../src/state'

export const PaymentTypesPage: CheckoutPage = () => {
  const { t } = useTranslation()
  const pageTitle = `${t('consumerLending:paymentOptions:title')} | ${t('common:brandName')}`

  const offerDetailPCL = useOfferDetailPCL()
  const isPbiRejected = usePBIRejected()
  const preselectedPaymentType = usePreselectedPaymentType()

  return (
    <>
      <Head title={pageTitle} />
      <PaymentTypes />
      <TrackOnMount
        eventName={TrackingEvent.VIEWED_CL_ENTRY_PAGE}
        eventProperties={{
          hasPCLEnabled: Boolean(offerDetailPCL),
          hasPBIEnabled: !isPbiRejected,
          preSelected: preselectedPaymentType ?? 'None',
        }}
      />
    </>
  )
}
